
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AttributeItem } from '@/store/modules/staticData/staticDataTypes';
import NoDataSelectItem from '@/components/selectItems/NoDataSelectItem.vue';
import CommonSelectItem from '@/components/selectItems/CommonSelectItem.vue';
import store from '@/store';

@Component({
  components: {
    NoDataSelectItem,
    CommonSelectItem,
  },
})
export default class AttributesAutocompleteField extends Vue {
  @Prop(Array) public value: string[];
  @Prop(Boolean) public loading: boolean;
  @Prop(Boolean) public disabled: boolean;

  @Watch('value', { immediate: true })
  private watchValue(value: string[]) {
    // console.debug('watchValue', value);
    this.fieldValue = value;
  }

  @Watch('fieldValue')
  private watchFieldValue(fieldValue: string[]) {
    // console.debug('watchFieldValue', fieldValue);
    this.$emit('input', fieldValue);
  }

  public fieldValue: string[] = [];
  public items: AttributeItem[] = [];

  private async created() {
    this.items = await store.getters['moduleStaticData/getAttributes'];
  }

  public filter(item: AttributeItem, queryText: string) {
    return (item.code + item.description).toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
  }

  public removeItem(item: AttributeItem) {
    const index = this.fieldValue.indexOf(item.code);
    if (index >= 0) {
      this.fieldValue.splice(index, 1);
    }
  }
}
